export interface CandidateSourceAvailability {
  id?: string;
  name?: string;
  type?: string;
  available?: boolean;
}

export const normalizeSourceId = (source?: string | null): string => (
  String(source || '').trim().toLowerCase()
);

export const getAvailableSourceIds = (
  sources?: CandidateSourceAvailability[] | null,
): string[] => {
  if (!Array.isArray(sources)) return [];

  return sources.reduce<string[]>((acc, source) => {
    const id = normalizeSourceId(source?.id);
    if (!id || source?.available !== true || acc.includes(id)) {
      return acc;
    }
    acc.push(id);
    return acc;
  }, []);
};

export const resolveAvailableSource = (
  currentSource: string | undefined | null,
  sources?: CandidateSourceAvailability[] | null,
): string | null => {
  const current = normalizeSourceId(currentSource);
  const available = getAvailableSourceIds(sources);

  if (current && available.includes(current)) {
    return current;
  }

  return available[0] || null;
};
